export default __webpack_public_path__ + "static/media/harmay-iphone2.4cde822d.png";